import vueUIInitiator from '../../modules/vue-ui-initiator';
import FireSafetyDocsPlateParent from './components/FireSafetyDocsPlateParent.vue';
import UrbanDocsPlate from '../../vue-components/UrbanDocsPlate';
import VideoBlock from '../../vue-components/VideoBlock';
import ProjectsGrid from '../../vue-components/ProjectsGrid';
import Projects from '@/js/vue-components/pages/urban/Projects.vue';

vueUIInitiator('js-projects', Projects, 'projects');
vueUIInitiator('js--urban-fire-safety-docs-plate', FireSafetyDocsPlateParent, 'fire-safety-docs-plate-parent');
vueUIInitiator('js--urban-docs-plate', UrbanDocsPlate, 'urban-docs-plate');
vueUIInitiator('js--video-block', VideoBlock, 'video-block');
vueUIInitiator('js--projects-grid', ProjectsGrid, 'projects-grid');
